import { render, staticRenderFns } from "./BlockTitleWithSubtitle.vue?vue&type=template&id=7d1b9eee&scoped=true&"
import script from "./BlockTitleWithSubtitle.vue?vue&type=script&lang=js&"
export * from "./BlockTitleWithSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./BlockTitleWithSubtitle.vue?vue&type=style&index=0&id=7d1b9eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b9eee",
  null
  
)

export default component.exports